import "reflect-metadata";
import "reflect-metadata";
import runApp from "./app";
import { environment, sentryDSN, sentryTracesSampleRate } from "./config";

import createContainer from "./di.config";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";

import "./views";
import "./assets/themes/default.theme.scss";

if (sentryDSN) {
  Sentry.init({
    dsn: sentryDSN,
    environment: environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance monitoring — configurable via REACT_APP_SENTRY_TRACES_SAMPLE_RATE (default 0.2)
    tracesSampleRate: sentryTracesSampleRate,
    // Session Replay — capture 10 % of sessions, 100 % of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // https://docs.sentry.io/clients/javascript/tips/
    ignoreErrors: [
      // Random plugins/extensions
      "top.GLOBALS",
      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      "originalCreateNotification",
      "canvas.contentDocument",
      "MyApp_RemoveAllHighlights",
      "http://tt.epicplay.com",
      "Can't find variable: ZiteReader",
      "jigsaw is not defined",
      "ComboSearch is not defined",
      "http://loading.retry.widdit.com/",
      "atomicFindClose",
      // Facebook borked
      "fb_xd_fragment",
      // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
      // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
      "bmi_SafeAddOnload",
      "EBCallBackMessageReceived",
      // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
      "conduitPage",
      // Generic error code from errors outside the security sandbox
      // You can delete this if using raven.js > 1.0, which ignores these automatically.
      "Script error.",
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    allowUrls: [
      "backoffice.edalnice.cz",
      "backoffice.edalnice.gov.cz",
      "backoffice.test.edalnice.cz",
      "backoffice.test.edalnice.gov.cz",
      "backoffice.dev.edalnice.cz",
      "backoffice.dev.edalnice.gov.cz",
      "localhost:3000",
    ],
  });
}

const container = createContainer();

runApp(container);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
